import * as yup from 'yup';
import { transformAsCurrency } from '~/utils/functions';

export const schemaAjusteEstoque = yup
  .object({
    cod_loja: yup.number().required().typeError('Loja obrigatória'),
    produtos: yup
      .object()
      .shape({
        value: yup.string().required(),
        label: yup.string().required(),
      })
      .required(),
    ajuste: yup
      .object()
      .shape({
        value: yup.number().required(),
      })
      .required(),
    qtd_alteracao: yup
      .mixed()
      .required()
      .test(
        'maior-que-zero',
        'Quantidade ajuste não pode ser negativa ou zero',
        (value) => {
          if (value === undefined || value === null || value === '') {
            return false;
          }
          const numericValue =
            typeof value === 'number' ? value : transformAsCurrency(value);
          return Number(numericValue) > 0;
        },
      ),
  })
  .required();
